// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError, AxiosResponse } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap, debounceTime } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { getResetNotifications } from '../../../apis/member';
import { getResetNotificationsActions, GetResetNotificationsSuccessPayload } from '../../actionCreators/notifications/getResetNotificationsActions';
import { RootAction } from '../../rootActionCreator';

const outputActions = {
  success: getResetNotificationsActions.success,
  failure: getResetNotificationsActions.failure
};

type RequestActionTypes = ActionType<
  typeof getResetNotificationsActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const getResetNotificationsEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      getType(getResetNotificationsActions.request)
    ),
    debounceTime(2000),
    switchMap((action: RequestActionTypes) => {

      return getResetNotifications()
        .then((resp: AxiosResponse<GetResetNotificationsSuccessPayload>) => {
          return getResetNotificationsActions.success({
            ...resp.data
          });
        })
        .catch((error: AxiosError) => {
          return getResetNotificationsActions.failure({ error });
        });
    })
  );
};
